import React, {useState} from 'react';
import 'date-fns';
import {
    Box,
    Button,
    CircularProgress,
    Grid,
    IconButton,
    makeStyles,
    Modal,
    Paper,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    Typography,
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LaunchIcon from '@material-ui/icons/Launch';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import WarningIcon from '@material-ui/icons/Warning';
import {Alert} from '@material-ui/lab';
import useStyles from '../styles/styles';
import {useLazyQuery} from '@apollo/react-hooks';
import {gql} from 'apollo-boost';
import theme from '../styles/theme';
import ParseResponse from '../utils/ParseResponse';
import {KeyboardDateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";


const useBoxStyles = makeStyles({
    root: {
        height: '400px',
        overflow: 'scroll'
    },
});

const TrafficSources = () => {
    const classes = useStyles();
    const boxClasses = useBoxStyles();
    const [open, setOpen] = useState(false);
    const [variables, setVariables] = useState({});
    const [modalData, setModalData] = useState({});

    const [selectedTab, setSelectedTab] = useState(0);
    const [loanRequestId, setLoanRequestId] = useState("")
    const [inputError, setInputError] = useState('')

    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [value, setValue] = useState(null)

    const [getLoanRequestLog, {loading, error, data, refetch}] = useLazyQuery(gql`
        query LoanRequestLog(
            $loanRequestId: UUID!
            $startDate: String
            $endDate: String
        ) {
            loanRequestLog(
                loanRequestId: $loanRequestId
                startDate: $startDate
                endDate: $endDate
            ) {
                id
                loanRequestId
                request
                response
                statusCode
                error
            }
        }
    `, {
        context: {
            clientName: "kgraphql"
        }
    });


    const handleOpen = (request, response) => {
        setModalData({
            request,
            response
        });
        setOpen(true);
    };

    const handleClose = () => {
        setModalData({});
        setOpen(false);
    };

    const handleTabClick = (e, val) => {
        setSelectedTab(val);
    };


    const LoanRequestLogTable = () => {
        return (
            <Table className={classes.table} size="small">
                <TableHead>
                    <TableRow>
                        <TableCell variant="head">View Raw Data</TableCell>
                        <TableCell variant="head">Id</TableCell>
                        <TableCell variant="head">Created Date</TableCell>
                        <TableCell variant="head">Status Code</TableCell>
                        <TableCell variant="head">Message</TableCell>
                        <TableCell variant="head">URI</TableCell>
                        <TableCell variant="head">Loan Request Id</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.loanRequestLog ? (
                            <TableRow>
                                <TableCell variant="body">
                                    <IconButton
                                        onClick={() => handleOpen(data.loanRequestLog.request, data.loanRequestLog.response)}>
                                        <LaunchIcon/>
                                    </IconButton>
                                </TableCell>
                                <TableCell variant="body">{data.loanRequestLog.id}</TableCell>
                                <TableCell variant="body">{'N/A'}</TableCell>
                                <TableCell variant="body">{data.loanRequestLog.statusCode === 200 ?
                                    <CheckBoxIcon style={{color: theme.palette.success.main}}/> :
                                    <WarningIcon style={{color: theme.palette.error.main}}/>}</TableCell>
                                <TableCell
                                    variant="body">{data.loanRequestLog?.message?.length ? data.loanRequestLog.message : 'N/A'}</TableCell>
                                <TableCell variant="body">{data.loanRequestLog?.uri}</TableCell>
                                <TableCell variant="body">{data.loanRequestLog?.loanRequestId ?? 'N/A'}</TableCell>
                            </TableRow>
                        )
                        : null}
                </TableBody>
            </Table>
        );
    };

    return (
        <>
            <Typography variant="h2">
                Loan Request Log
            </Typography>

            <ExpansionPanel expanded>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography variant="h5">Filter Logs</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.fliter}>
                    <Grid container spacing={2} justify="center" alignItems="center">
                        <Grid item xs={12}>
                            <Box className={classes.fliterBox} style={{marginTop: 0, paddingBottom: '20px'}}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Grid item xs={4}>
                                            <TextField
                                                id="loanRequestId"
                                                name="loanRequestId"
                                                label="Search by Loan Request ID"
                                                value={loanRequestId || ''}
                                                onChange={(evt) => setLoanRequestId(evt.target.value)}
                                                onBlur={evt => evt.target.value ? setInputError('') : setInputError('Loan Request Id is required')}
                                                fullWidth
                                                error={!loanRequestId?.length}
                                            />
                                            {inputError ? <Alert severity={'error'}>{inputError}</Alert> : null}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDateTimePicker
                                                disableFuture
                                                ampm={false}
                                                variant="inline"
                                                margin="normal"
                                                id="date-picker-start"
                                                label="Start Date"
                                                value={startDate || null}
                                                onChange={date => setStartDate(date.toISOString())}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                className={classes.formControl}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDateTimePicker
                                                disableFuture
                                                ampm={false}
                                                variant="inline"
                                                margin="normal"
                                                id="date-picker-start"
                                                label="End Date"
                                                value={endDate || null}
                                                onChange={date => setEndDate(date.toISOString())}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                className={classes.formControl}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </Grid>
                                <Grid item xs={4}>
                                    <Alert severity={'warning'}>Note: The date ranges are optional and are used as a
                                        fallback when a LoanRequest can't be found (ie: an error before persisted to the
                                        table)</Alert>
                                </Grid>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Button type="submit" variant="contained" color="secondary" fullWidth onClick={() => {
                                if (!loanRequestId) {
                                    setInputError('Loan Request Id is required')
                                    return
                                }

                                getLoanRequestLog({
                                    variables: {
                                        loanRequestId: loanRequestId,
                                        startDate: startDate,
                                        endDate: endDate
                                    }
                                })
                            }
                            }>
                                Fetch Loan Request Log
                            </Button>
                        </Grid>
                    </Grid>
                </ExpansionPanelDetails>
            </ExpansionPanel>
            <Paper className={classes.paper}>
                {!loading && error ? (
                    <>
                        <Alert severity="error">There was an error!</Alert>
                        {/* <pre>{JSON.stringify(error, null, 2)}</pre> */}
                    </>
                ) : null}
                {loading ? (
                    <div className={classes.loadingBar}>
                        <CircularProgress
                            size={50}
                            thickness={4}
                        />
                    </div>
                ) : null}
                {!loading && !error && !data?.loanRequestLog?.error ? (
                    <>
                        {data?.loanRequestLog ?
                            <LoanRequestLogTable/>
                            : (
                                <Alert severity="error">No Logs at this time!</Alert>
                            )}
                    </>
                ) : data?.loanRequestLog?.error ? (
                    <Alert severity="error">{data.loanRequestLog.error}</Alert>
                ) : null}
            </Paper>
            <Modal
                open={open}
                onClose={handleClose}
            >
                <Paper className={classes.modal}>
                    <Tabs
                        aria-label="raw data tabs"
                        value={selectedTab}
                        onChange={handleTabClick}
                        indicatorColor="secondary"
                        centered
                    >
                        <Tab
                            label="Request Raw Tab"
                            id="raw-data-0"
                        />
                        <Tab
                            label="Response Raw Tab"
                            id="request-data-0"
                        />
                    </Tabs>
                    <Box
                        component="div"
                        role="tabpanel"
                        hidden={selectedTab !== 0}
                        className={boxClasses.root}
                    >
                        {modalData.request ? (
                            <ParseResponse data={modalData.request}/>
                        ) : null}
                    </Box>
                    <Box
                        component="div"
                        role="tabpanel"
                        hidden={selectedTab !== 1}
                        className={boxClasses.root}
                    >
                        {modalData.response ? (
                            <ParseResponse data={modalData.response}/>
                        ) : null}
                    </Box>
                </Paper>
            </Modal>
        </>
    )
}

export default TrafficSources;
